/* eslint-disable */
/* tslint:disable */

/** updateWorkerNotificationPreferences
 * method: put
 * summary: Update notification preference for a worker in specific institutions and update excludedClients list
 */

import type {
  EditWorkerNotificationInputDto,
  GeneralOkNotOkResultDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/profile/edit-notification`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/profile/edit-notification`

export type RequestBody = EditWorkerNotificationInputDto

export type UpdateWorkerNotificationPreferencesSuccess = GeneralOkNotOkResultDto
export type UpdateWorkerNotificationPreferencesError = ApiResponseDto
